import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { DatepickerComponent } from "@components/datepicker/datepicker.component";
import { InputComponent } from "@components/input/input.component";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { SaveButtonComponent } from "@components/save-button/save-button.component";
import { SimpleSelectorComponent } from "@components/simple-selector/simple-selector.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import _ from "lodash";
import { BusyService } from "~app/common/components/busy/busy.service";
import { IRadiobuttonItem } from "~app/common/components/radiobuttongroup/radiobutton/IRadiobuttonItem";
import { CertifikatTyper } from "~app/common/models/constants";
import { FormBinderService } from "~app/common/services/form-binder.service";
import { CertifikatDto, defaultCertifikat } from "../certifikat-models";
import { CertifikatService } from "../certifikat.service";

type CreateData = {
    mode: "create";
};

type EditData = {
    certifikat: CertifikatDto;
    mode: "edit";
};

export type CertifikatEditDialogData = EditData | CreateData;

@Component({
    selector: "rask-certifikat-edit-dialog",
    templateUrl: "./certifikat-edit-dialog.component.html",
    styleUrls: ["./certifikat-edit-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        InputComponent,
        SimpleSelectorComponent,
        DatepickerComponent,
        RadiobuttonGroupComponent,
        SaveButtonComponent,
        ButtonComponent
    ]
})
export class CertifikatEditDialogComponent {
    protected certifikat: CertifikatDto;
    protected certifikatstyper = _.clone(CertifikatTyper.allaCertifierbaraTyper);
    protected form: UntypedFormGroup;
    protected mode: "create" | "edit";
    protected radioButtonOptions: IRadiobuttonItem[] = [
        {
            value: "Ja",
            key: true
        },
        {
            value: "Nej",
            key: false
        }
    ];

    private readonly busyService = inject(BusyService);
    private readonly certifikatService = inject(CertifikatService);
    private readonly formBinderService = inject(FormBinderService);
    private readonly modal = inject(NgbActiveModal);

    private certifikatEditDialogData: CertifikatEditDialogData;

    get data() {
        return this.certifikatEditDialogData;
    }

    set data(value: CertifikatEditDialogData) {
        this.mode = value.mode;
        this.certifikat = value.mode === "create"
            ? _.cloneDeep(defaultCertifikat)
            : value.certifikat;
        this.form = this.formBinderService.CreateGroup(this.certifikat);
        this.certifikatEditDialogData = value;
    }

    protected onCancel() {
        this.modal.close();
    }

    protected onSave() {
        const work = this.mode === "create"
            ? this.certifikatService.createCertifikat(this.certifikat)
            : this.certifikatService.saveCertifikat(this.certifikat);

        const response$ = this.busyService.addWork(work);
        response$.subscribe(() =>
            this.modal.close(this.certifikat));
    }
}
